import React from 'react';
import './CartTotal.less';

import {convertPrice} from "helpers/format.helper";

export const CartTotal = ({name, price, isSubtotal}) => {
	return (
		<div className={`cart-total ${isSubtotal ? 'cart-total--subtotal' : ''}`}>
			<span className="cart-total__name">{name}</span>
			<span className="cart-total__price">{convertPrice(price)}</span>
		</div>
	);
};
